export const environment = {
  production: false,
  name: 'qa',
  sdk: {
    url: 'https://sbx.button.pay.synapsolutions.com/web/2.1.2/sdk.js',
    idEnvironment: 'sandbox',
    publicAppKey: '1931f9f9-3715-4997-8581-a84a073eccd0',
    loadOnStartup: true,
    allowBootstrapWithoutSdk: true
  },
  paylink: {
    baseUrl: 'https://sbx.api.synapsis.pe'
  }
};
